import React, { useEffect, useState } from 'react';
import { Layout } from '../../components/Layout';
import { api } from '../../services/api';
import { Advocate } from '../../types';

interface AdvocateListResponse {
  advocates: Advocate[];
  totalCount: number;
}

export function AdvocateList() {
  const [advocates, setAdvocates] = useState<Advocate[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    async function loadAdvocates() {
      try {
        const data = await api.get<AdvocateListResponse>('/tenant/advocates');
        setAdvocates(data.advocates);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load advocates');
      } finally {
        setLoading(false);
      }
    }
    loadAdvocates();
  }, []);

  return (
    <Layout>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h1>Advocates</h1>
        <button
          style={{
            padding: '10px 20px',
            backgroundColor: '#1a237e',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
          onClick={() => alert('Invite advocate form coming soon')}
        >
          + Invite Advocate
        </button>
      </div>

      {error && (
        <div style={{ backgroundColor: '#ffebee', color: '#c62828', padding: '12px', borderRadius: '4px', marginBottom: '16px' }}>
          {error}
        </div>
      )}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div style={{ backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #eee' }}>
                <th style={{ textAlign: 'left', padding: '16px' }}>Name</th>
                <th style={{ textAlign: 'left', padding: '16px' }}>Email</th>
                <th style={{ textAlign: 'left', padding: '16px' }}>Role</th>
                <th style={{ textAlign: 'left', padding: '16px' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {advocates.map((advocate) => (
                <tr key={advocate.userId} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '16px' }}>
                    <strong>{advocate.givenName} {advocate.familyName}</strong>
                  </td>
                  <td style={{ padding: '16px' }}>{advocate.email}</td>
                  <td style={{ padding: '16px' }}>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      backgroundColor: advocate.role === 'tenant-admin' ? '#e3f2fd' : '#f5f5f5',
                      color: advocate.role === 'tenant-admin' ? '#1565c0' : '#666',
                    }}>
                      {advocate.role === 'tenant-admin' ? 'Tenant Admin' : 'Advocate'}
                    </span>
                  </td>
                  <td style={{ padding: '16px' }}>
                    <span style={{
                      padding: '4px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      backgroundColor: advocate.status === 'active' ? '#e8f5e9' : '#ffebee',
                      color: advocate.status === 'active' ? '#2e7d32' : '#c62828',
                    }}>
                      {advocate.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Layout>
  );
}
